import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { ListInsurersQuery } from '@/core/domain/people/Insurers/Insurers.types';

function InsurerExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListInsurersQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col lg={7} md={12} span={24}>
        <Input
          value={queryParams?.cnpj}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, cnpj: value }))
          }
          placeholder={intl.formatMessage({
            id: 'insurers.filters.cnpj',
          })}
        />
      </Col>

      <Col lg={6} md={12} span={24}>
        <Input
          value={queryParams?.fantasyName}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, fantasyName: value }))
          }
          placeholder={intl.formatMessage({
            id: 'insurers.filters.fantasyName',
          })}
        />
      </Col>

      <Col lg={5} md={12} span={24}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col lg={5} md={12} span={24}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default InsurerExtraFilters;
